import React from 'react';
import { ReactComponent as Bank } from '../../../assets/images/svg/bank.svg';
import { ReactComponent as CreditCard } from '../../../assets/images/svg/credit-card.svg';
import { ReactComponent as Wallet } from '../../../assets/images/svg/wallet.svg';

export const PAYMENT_METHOD_TYPES = {
  ACCOUNT_BALANCE: 1,
  ACH: 2,
  CREDIT_CARD: 3,
};

export default {
  [PAYMENT_METHOD_TYPES.ACCOUNT_BALANCE]: 'AccountBalance',
  [PAYMENT_METHOD_TYPES.ACH]: 'ACH',
  [PAYMENT_METHOD_TYPES.CREDIT_CARD]: 'CreditCard',
};

export const PAYMENT_METHOD_TYPES_ICONS = {
  [PAYMENT_METHOD_TYPES.ACCOUNT_BALANCE]: <Wallet />,
  [PAYMENT_METHOD_TYPES.ACH]: <Bank />,
  [PAYMENT_METHOD_TYPES.CREDIT_CARD]: <CreditCard />,
};
